import { teamAPI } from "@/api";
import OnboardingType from "@/constants/OnboardingType";

const IS_DEV_ENV = process.env.NODE_ENV === "development";

/* eslint-disable new-cap */
const safeIntercom = ( ...args ) => {
	if ( window.Intercom ) {
		window.Intercom( ...args );
	}
	if ( IS_DEV_ENV ) {
		console.info( "INTERCOM:", ...args );
	}
};

export default function( { store, } ) {
	return {
		async update() {
			const user = store.getters[ "userProfile/userProfile" ];

			/* eslint-disable camelcase */
			const userData = {
				email: user.email,
				name: user.name,
				avatar: {
					type: "avatar",
					image_url: user.picture,
				},
				user_hash: user.intercomUserHash,
				source: user.source,
			};
			/* eslint-enable camelcase */

			if ( user.onboarding?.signupTeamId ) {
				/* eslint-disable camelcase */
				userData.initial_signup_team_id = user.onboarding.signupTeamId;
				try {
					const demoData = await teamAPI.fetchTeamMemberDemographics( {
						teamId: user.onboarding.signupTeamId,
						personId: user.personId,
					} );

					if ( user.onboarding.type === OnboardingType.LEAD ) {
						userData.team_lead_personal_growth_priority = demoData.growth.selectedOpportunity;
						userData.team_lead_initial_team_growth_priority = demoData.teamGrowth;
					} else {
						userData.team_member_personal_growth_priority = demoData.growth.selectedOpportunity;
					}
				} catch {
					// there's really nothing to be done here
					// we either got a 404 because this user hasn't answered the onboarding questions yet
					// or we got some other kind of error, but we still need to allow the intercom call to fire
				}
				/* eslint-enable camelcase */
			}

			safeIntercom( "update", userData );
		},
		trackEvent( eventName, metadata ) {
			safeIntercom( "trackEvent", eventName, metadata );
		},
		shutdown() {
			safeIntercom( "shutdown" );
		},

		//
		// event API
		//
		userCancellationRequest( personId, reasons = [], comments = "" ) {
			return this.trackEvent( "User Cancellation Request", {
				person_id: personId,
				reasons: reasons.map( reason => `${ reason }`.trim() ).join( "," ),
				comments,
			} );
		},
		show() {
			safeIntercom( "show" );
		},
		hide() {
			safeIntercom( "hide" );
		},
	};
}
/* eslint-enable new-cap */



// WEBPACK FOOTER //
// ./src/lib/intercom.js